module.exports = __webpack_public_path__ + "static/media/Flower 2.1bd1c426.svg";